/** "1 element", "2 elements": the count and the noun that agrees with it. */
export function plural(count: number, noun: string): string {
  return `${String(count)} ${noun}${count === 1 ? "" : "s"}`;
}
